import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsRequestChangeModalOpen, openRequestChangeModal } from '../store';

/**
 * Encapsulates the Request Changes modal visibility state and its open/close actions,
 * so screens don't dispatch openRequestChangeModal directly.
 */
export const useRequestChangeModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(getIsRequestChangeModalOpen);

    const open = useCallback(() => {
        dispatch(openRequestChangeModal(true));
    }, [dispatch]);

    const close = useCallback(() => {
        dispatch(openRequestChangeModal(false));
    }, [dispatch]);

    return { isOpen, open, close };
};
